interface ProgressBarProps {
  /** 1-based current index. */
  current: number;
  total: number;
}

export default function ProgressBar({ current, total }: ProgressBarProps) {
  const safeTotal = Math.max(1, total);
  const clamped = Math.min(Math.max(1, current), safeTotal);
  const pct = ((clamped - 1) / safeTotal) * 100;
  return (
    <div
      className="h-1.5 w-full overflow-hidden rounded-full bg-muted"
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={1}
      aria-valuemax={safeTotal}
      aria-label={`Question ${clamped} of ${safeTotal}`}
    >
      <div
        className="h-full bg-primary transition-[width] duration-200 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
